import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  options: {
    customProperties: true
  }
});

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#224D9C',
        secondary: '#EA532E',
        disabled: '#E8E8E8',
        accent: '#8c9eff',
        error: '#D84848',
        success: '#AECC46',
        background: "#EA532E",
        textColor: '#333333',
        objetivos_gerais: '#EA532E',
        voce_sabia: '#EA532E',
        atencao: '#EA532E',
        video_aula: '#EA532E',
        recapitulando: '#EA532E',
        atividade: '#EA532E',
      },
      dark: {
        primary: '#fff',
        secondary: '#fff',
        disabled: '#C6C6C6',
        accent: '#8c9eff',
        error: '#D84848',
        success: '#fff',
        background: "#111",
        white: '#010101',
        textColor: '#fff',
        objetivos_gerais: '#fff',
        apresentacao: '#fff',
        voce_sabia: '#fff',
        atencao: '#fff',
        video_aula: '#fff',
        recapitulando: '#fff',
        atividade: '#fff',
      },
    },
  },
});
